/**
 * Why a Nim first message's button fields cannot be sent, or '' when they can.
 * The button is optional, but needs both its text and an https link: the same
 * rule the admin API enforces, checked here so the form can say what to fix.
 */
export function buttonError(label: string, uri: string): string {
  if (!label && !uri) return '';
  if (!label) return 'Add the button text, or clear the link';
  if (!uri) return 'Add the button link, or clear the text';
  if (!uri.startsWith('https://')) return 'The button link must start with https://';
  return '';
}
